import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'organizationStatusPipe'
})
export class OrganizationStatusPipe implements PipeTransform {

  transform(value: string|null): string {
    switch(value) {
      case OrganizationStatusEnum.WAITING: return 'Beklemede';
      case OrganizationStatusEnum.CANCELLED: return 'İptal';
      case OrganizationStatusEnum.COMPLETED: return 'Tamamlandı';
      case OrganizationStatusEnum.IN_PROGRESS: return 'Devam Ediyor';
      default:return "Belirsiz"
    }
  }

}

export enum OrganizationStatusEnum {
  WAITING = 'waiting',
  IN_PROGRESS = 'in_progress',
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
}
